import useAPI from "./useAPI";
import React from "react";

export default function useAdminListSMS(props) {
  const { onSave } = props;

  const { query: postSendSMS } = useAPI({
    type: "post",
    url: `campaign/launch-sms`,
    defer: true,
    // Ne pas définir body ici, on le passera dynamiquement
  });

  const sendSMS = async (campaignId) => {
    try {
      // Confirmer avant d'envoyer
      if (!window.confirm(`Lancer la campagne SMS ?`)) {
        return;
      }

      // Passer le campaignId dynamiquement lors de l'appel
      await postSendSMS({
        body: { campaignId },
      });

      onSave({ success: true, message: "Campagne lancée !" });
    } catch (error) {
      console.error("Error sending SMS:", error);
      throw error;
    }
  };

  return {
    ...props,
    sendSMS,
  };
}
